import React from 'react';
import PropTypes from 'prop-types';

import { onEnter } from '../../../utilities/accessibility/onEnter';
import '../../../styles/scss/filters/list-filter-tab.scss'
const ListFilterTab = ({ isActive, label, onClick, value }) => (
  <div
    aria-label={label}
    className={`list-filter-tab ${isActive ? 'list-filter-tab-active' : ''}`}
    onClick={() => onClick(value, isActive)}
    onKeyDown={(event) => onEnter(event, () => onClick(value, isActive))}
    role="button"
    tabIndex="0"
  >
    <span>{label}</span>
  </div>
);

ListFilterTab.prototype = {
  isActive: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ListFilterTab;
